<template>
    <div style="width: 100%; height: 100%; margin: 0; padding: 20px; overflow-y: auto; text-align: left; box-sizing: border-box;">
        <side-menu-header :role="store.state.user.role"></side-menu-header>
        <div class="user__headers">
            About Us
        </div>
        <div style="margin-top: 5%">
            <pre style="white-space: pre-wrap">Our mission is to revolutionize the Out-of-Home (OOH) advertisement industry by infusing it with the on demand economy.

    The unique marriage of our projection technology with geo-fencing technology enables us to dynamically connect brands and drivers with specified targeted locations and consumers.

    In the current OOH market, it can take months to launch a single advertisement campaign. Unlike other platforms, ADWAY allows advertisers to launch campaigns within minutes and be street ready within days. Thanks to our built in real time analytics engine, our advertisers can track their campaigns' progress, as well as analyze and edit them with the click of a mouse. Making us one of the most versatile and novel ad mediums available.

    ADWAY pays drivers for displaying ads on the sides of their personal or company vehicles. We respect and cherish all drivers who take our platform to the road. Our drivers are independent operators who are not wedded to wraps or magnets, and do not have to ruin the appearance of their vehicles. We empower our drivers by giving them direct access to the live analytics and campaign stats through our app, which makes it easy for them to manage and control the displayed campaigns and consequent earnings.

    We love being a part of the future and changing the norm! Seeing people's reactions to the powerful images that are projected on the cars of our affiliated drivers excites and makes us proud.

    Now, we are happy to share the ADWAY experience with you!</pre>
        </div>
    </div>
</template>

<script>
import SideMenuHeader from './../../components/design/SideMenuHeader.vue'
import store from '@store/index.js'
export default {
  name: 'AboutUs',
  data: function () {
    return {
      store: store,
      accountLogin: null
    }
  },
  methods: {
  },
  components: {
    SideMenuHeader
  }
}
</script>

<style>
@media only screen and (max-width: 600px) {
  .user__headers{
    font-size: 24px !important;
  }

  pre{
    font-size: 14px !important;
  }
}
</style>
